import { ERequestStatus } from 'src/enums';
import { IAsyncDataStatus } from 'src/models';

export const isInitial = (requestState: IAsyncDataStatus) => requestState.status === ERequestStatus.IDLE;
export const isLoading = (requestState: IAsyncDataStatus) => requestState.status === ERequestStatus.PENDING;
export const isError = (requestState: IAsyncDataStatus) => requestState.status === ERequestStatus.ERROR;
export const isSuccess = (requestState: IAsyncDataStatus) => requestState.status === ERequestStatus.SUCCESS;

export const isServerError = (statusCode: number) => `${statusCode}`.startsWith('5');
